import { render } from "./FlowToFormActionDialog.vue?vue&type=template&id=1b65d1c4&ts=true"
import script from "./FlowToFormActionDialog.vue?vue&type=script&lang=ts"
export * from "./FlowToFormActionDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__